import { Screen } from "../../../shell/chrome";
import { useNav } from "../../../shell/router";
import { useMessagingCounts, messagingTabs } from "../messaging-tabs";
import { MessageBuilderPage } from "./builder/MessageBuilder";

/** Messaging > Message builder: shared email layouts and message templates, on the real API. */
export default function MessageBuilder() {
  const nav = useNav();
  const counts = useMessagingCounts();
  return (
    <Screen rail="messaging" tabs={messagingTabs(nav, "builder", counts)} activeTab="builder">
      <div style={{ flex: 1, minHeight: 0, display: "flex" }}>
        <MessageBuilderPage />
      </div>
    </Screen>
  );
}
